import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'

import AuthenticationDetails from './AuthenticationDetails'
import ChurnDetails from './ChurnDetails'
import HostnameDetails from './HostnameDetails'
import PhoneTailDetails from './PhoneTailDetails'

export default function ServiceDetail({
  errors,
  product,
  setData,
  setServicePassword,
  signup,
}) {
  if (!product.requirements.size) {
    return null
  }

  return (
    <div className="product-requirements">
      {product.requirements.map(requirement => {
        let Component
        const props = {
          key: requirement,
          errors,
          requirement,
          product,
          setData,
          signup,
        }

        switch (requirement.get('requirement')) {
          case 'authentication':
            Component = AuthenticationDetails
            props.setServicePassword = setServicePassword
            break

          case 'churn':
            Component = ChurnDetails
            break

          case 'hostname':
            Component = HostnameDetails
            break

          case 'phone-ext-count':
            return null

          case 'phone-tail':
            Component = PhoneTailDetails
            break

          default:
            throw new Error(`Unknown requirement ${requirement}`)
        }

        return <Component {...props} />
      })}
    </div>
  )
}

ServiceDetail.propTypes = {
  errors: Ipt.map.isRequired,
  product: Ipt.record.isRequired,
  setData: Pt.func.isRequired,
  setServicePassword: Pt.func.isRequired,
  signup: Ipt.record.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Signup/ServiceDetail/index.jsx